export enum AccountInformationFormFields {
  EMAIL = 'email',
  POSTAL_CODE = 'postalCode',
  ROLES_FLAG = 'rolesFlag',
  ROLE = 'role',
  RECAPTCHA_REACTIVE = 'recaptchaReactive',
  PASSWORD = 'password',
  CONFIRM_EMAIL = 'confirmEmail',
  ACCOUNT_NUMBER = 'accountNumber'
}
